var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2103_7071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8871 6.38661C17.7263 6.16662 13.8945 1 9.00067 1C4.10681 1 0.274875 6.16662 0.114232 6.3864C-0.0380775 6.59511 -0.0380775 6.87817 0.114232 7.08688C0.274875 7.30687 4.10681 12.4735 9.00067 12.4735C13.8945 12.4735 17.7263 7.30684 17.8871 7.08706C18.0396 6.87838 18.0396 6.59511 17.8871 6.38661ZM9.00067 11.2866C5.39582 11.2866 2.27364 7.85739 1.34941 6.73634C2.27245 5.6143 5.38809 2.18691 9.00067 2.18691C12.6053 2.18691 15.7273 5.6155 16.6519 6.73715C15.7289 7.85915 12.6132 11.2866 9.00067 11.2866Z",
    fill: "#4F4A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00021 3.17599C7.03684 3.17599 5.43945 4.77339 5.43945 6.73675C5.43945 8.70011 7.03684 10.2975 9.00021 10.2975C10.9636 10.2975 12.561 8.70011 12.561 6.73675C12.561 4.77339 10.9636 3.17599 9.00021 3.17599ZM9.00021 9.11056C7.69123 9.11056 6.6264 8.04569 6.6264 6.73675C6.6264 5.42781 7.69126 4.36294 9.00021 4.36294C10.3092 4.36294 11.374 5.42781 11.374 6.73675C11.374 8.04569 10.3092 9.11056 9.00021 9.11056Z",
    fill: "#4F4A62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2103_7071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 13.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/show-icon.28cb8eefd5441254f7315459f13f9e65.svg";
export { ForwardRef as ReactComponent };